import { Observable } from "rxjs";
import { EPackageType } from "../enum/e-package-type";
import { PackageService } from "./package.service";
import { Package } from "../models/package";
import { PackageApiService } from "../package-api.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class PackagePlatformService extends PackageService{

    public getPackages(discriminator: EPackageType): Observable<Package[]> {
        return this.injector.get(PackageApiService).getPackages(discriminator);
    }
    public getPackage(packageId: number): Observable<Package> {
        return this.injector.get(PackageApiService).getPackage(packageId);
    }
    public createPackage(pack: Package): Observable<Package> {
        return this.injector.get(PackageApiService).createPackage(pack);
    }
    public deletePackage(pack: Package): Observable<number> {
        return this.injector.get(PackageApiService).deletePackage(pack);
    }
    public editPackage(pack: Package): Observable<any> {
        return this.injector.get(PackageApiService).editPackage(pack);
    }

}